import styled from 'styled-components';
import {Column, Row} from '../../common/Layouts/Layouts';
import getRatingsColor from './../../../../../shared/utils/getRatingsColor';
import StarIconRating from '../../../../Icons/RatingStarIcon';
import ProgressBar from '../../DetailsPage/ProgressBar/ProgressBar';

export const HotelTotalReviewWrapper = styled.div(
  props => `
      flex-direction: column;
      position:relative;
      align-items: flex-end;
      display: flex;
  `,
);

export const ReviewAndRatingOuterContainer = styled.div(
  props => `
  position:relative;
  `,
);


export const TotalReviewCountText = styled.span(
  props => `
    font-size:1rem;
    color: #9b9b9b;
    padding-top:.5rem;
    .countText{
        color: #4a4a4a;
        font-weight: ${props.theme.font.fontWeight.black};
    }
  `,
);

export const AverageReviewWrapper = styled.div`
  background-color: ${props => props.bgColor};
  display: flex;
  padding: 0.4rem 0.6rem 0.2rem;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
`;

export const AverageReviewText = styled.span(
  props => `
    font-size: ${props.theme.font.base};
    font-weight: ${props.theme.font.fontWeight.black};
    color: ${props.theme.colors.white.base};
    text-align: center;
  `,
);


export const OutofRatingText = styled.span`
  font-size: 1rem;
  color: #fff;
  font-weight: 200;
`;
